<template>
	<div>
		<div class="border rounded-6 py-3 mb-4 position-relative">
	    <div :id="data_card.id" class="position-absolute" style="top: -70px"></div>
	    <div class="w-100 position-relative" style="height: 5px;top: -16px;border-top-left-radius: 6px;border-top-right-radius: 6px;" :style="{backgroundColor: data_card.card_color_accent}"></div>
	    <div class="px-4">
	      <div class="pb-3">
	        <div class="row no-gutters">
	          <div class="col-12 col-md-12">
	            <p class="mb-0 font-bold text-20 body-2-2">{{data_card.card_name}}</p>
	            <p class="mb-0 font-regular body-2 text-14">{{$t('hotel.concierge.the-benefits-you-get')}}</p>
	          </div>
	        </div>
	      </div>
	      <div class="py-3 border-top border-bottom">
	        <!-- List -->
	        <div class="row slim-grid-row mb-2" v-for="benefit_card in data_card.benefit">
	          <div class="col-1">
	            <img src="../../../../assets/img/icon/correct.png" class="position-relative" width="13" style="top: -2px">
	          </div>
	          <div class="col-11">
	            <p class="mb-0 body-2-2 font-semibold text-14">{{benefit_card}}</p>
	          </div>
	        </div>
	        <!-- Product Reward -->
	        <template v-if="data_card.return_product.length > 0">
	          <p class="mb-2 mt-3 font-bold body-2-2 text-14">Reward yang didapat</p>
	          <flickity ref="flickity" class="banner"
	            :options="flickityOptionsReward">
	            <template v-for="(product_slide,index) in data_card.return_product">
	              <div class="carousel-cell w-90 mr-3 rounded-6 border" v-if="index < 3">
	                <div class="w-100">
	                  <img :src="product_slide.image_url" class="rounded-6 w-100 object-fit h-slide-voucher-member">
	                  <div class="py-2 px-3">
	                    <p class="mb-0 body-2-2 font-bold text-truncate text-16">{{product_slide.name}}</p>
	                    <div class="row slim-grid-row">
	                      <div class="col-12">
	                        <p class="mb-0 body-2 text-14 font-semibold d-inline-block">{{$t('hotel.concierge.only-for')}} {{data_card.card_name}}</p>
	                      </div>
	                    </div>
	                  </div>
	                </div>
	              </div>  
	            </template>
	          </flickity>
	          <!-- See More -->
	          <div class="row slim-grid-row mt-4" v-if="data_card.return_product.length > 3">
	            <div class="col-12 text-right">
	              <p class="mb-0 body-2-2 font-semibold text-14 underline cursor-pointer text-green" @click="detail()">{{$t('hotel.action.show-more')}}</p>
	            </div>
	          </div>
	        </template>
	      </div>
	      <div class="my-2" v-if="error != ''">
          <ErrorMessage :message="error" />
        </div>
	      <div class="pt-3 pb-1" v-if="!disabled_register">
	        <button type="button" :disabled="disabled_btn" class="button-primary w-100" @click="show_tc = true">
	        	<pulse-loader :loading="push_loading" color="#fff" v-if="push_loading"></pulse-loader>
	        	<template v-else>
	        		{{$t('general.register-now')}}
	        	</template>
	      	</button>
	      </div>
	    </div>
	  </div>
    <warning-box 
      v-if="show_confirm"  
      @yes="pushData"
      @no="show_confirm = false"
      :title="$t('warning-message.register_member.title')"
      :body="$t('warning-message.register_member.message')+' '+data_card.card_name+' member?'"
      :btn_secondary="$t('general.cancel')"
      :btn_primary="$t('general.continue')">  
    </warning-box>


    <template v-if="show_tc">
      <transition name="list">
        <div class="popup-box popup-box-bg">
          <div class="position-relative" >
            <div class="row no-gutters justify-content-center">
              <div class="fixed-top d-block nav-bottom">
                <div class="custom-container-fluid px-0">
                  <div class="row justify-content-center no-gutters">
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                      <div class="px-3 pt-4">
                        <div class="rounded-4 bg-white p-4">
                          <img src="../../../../assets/img/icon/cancel.png" class="d-inline-block p-2 rounded-3 bg-back mx-4 cursor-pointer position-absolute" width="33" style="z-index: 1038;right: 0" @click="show_tc = false;term_conditions_check = false">
                          <div class="px-2">
                            <p class="font-semibold text-20 mb-3">{{$t('merchant.term-condition')}}</p>
                            <div style="overflow-y: scroll;height: 55vh;">
                            	<div class="mb-3 body-2-2 text-14 font-regular html-desc" v-html="data_card.terms_and_conditions"></div>
                            </div>
                            <div class="pt-3 pb-1">
                            	<div class="mb-2">
											          <div class="w-16px rounded text-center delay mt-2px mr-2 d-inline-block cursor-pointer text-13 position-relative align-top" :class="{'bg-green border-2-green':term_conditions_check}" style="border: 2px solid #9599a0" @click="term_conditions_check = !term_conditions_check">
											            <img src="../../../../assets/img/icon/correct-white.png" class="position-relative" width="10" style="top: -9px">
											          </div>
											          <p class="mb-0 body-2-2 font-regular position-absolute d-inline-block cursor-pointer w-80"><span @click="term_conditions_check = !term_conditions_check">{{$t('hotel.concierge.agree-to-terms')}}</span></p>
											        </div>
											        <button 
											        	type="button" 
											        	:disabled="push_loading || !term_conditions_check" 
											        	:class="{'button-disabled': push_loading || !term_conditions_check}" 
											        	class="button-primary w-100"
											        	@click="pushData">
											        	<pulse-loader :loading="push_loading" color="#fff" v-if="push_loading"></pulse-loader>
											        	<template v-else>
											        		{{$t('general.register-now')}}
											        	</template>
											      	</button>
											      </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </template>

	</div>
</template>
<script>
	import Flickity from 'vue-flickity';
	import {post} from '@/services/index.js'
	import WarningBox from '@/components/general/WarningBox'
	import {mapGetters} from "vuex";
	export default{
		props: ['data_card','disabled_btn','disabled_register'],
		components:{
			Flickity,
			WarningBox
		},
		data(){
			return{
				flickityOptionsReward: {
          initialIndex: 0,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: true,
          cellAlign: "left",
          draggable: true,
          wrapAround: false,
        },
        push_loading: false,
        show_confirm: false,
        error: '',
        show_tc: false,
        term_conditions_check: false
			}
		},
		methods:{
			...mapGetters(['getMerchant']),
			detail(){
				this.$emit("detail",this.data_card)
			},
			pushData(){
				if(!this.push_loading && this.term_conditions_check){
					this.show_confirm = false
					this.push_loading = true
					this.error = ''
					this.$emit("push",true)
					post("CONCIERGE","membership/join-request",{
						merchant_id: this.getMerchant().id,
						member_card_id: this.data_card.id
					}).then(response=>{
						let res = response.data
						if(res.success){
							this.$emit('done')
						}else{
							this.error = res.message
						}
						this.show_tc = false
						this.push_loading = false
						this.$emit("push",false)
					})
				}
			}
		}
	}
</script>
<style scoped>
	.popup-box{
    position: fixed;
    height: 100vh;
    width: 100%;
    z-index: 9999;
    top: 0;
    left: 0;
    bottom: 0;
  }
  .popup-box-bg{
    background-color: rgba(0,0,0,.5)!important;
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/concierge/member/MemberCardItem.vue